module.exports = __webpack_public_path__ + "static/img/Waqa-Blake.f262599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Waqa-Blake.jpg
// module id = ycgO
// module chunks = 0